import React from "react";
import styled from 'styled-components';

const ModalCustomized = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  height: 100%;
  padding-top: ${props => props.isContainerTelcel ? "0px" : "30px"};
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  overflow:scroll;
  z-index: 1000;
`;

const Title = styled.p`
    color: #ffffff;
    width:auto !important;
    max-height: 68px !important;
    font-family: "AMX-Regular" 
    font-size: ${props => props.isContainerTelcel ? "16px" : "18px"};
    text-align: center;
    margin: ${props => props.isContainerTelcel ? "5% 5% 16px 5%" : "5% 5% 5% 5%"};
    ${props => props.isContainerTelcel ? "line-height: 24px" : ""}
`;

const Subtitle = styled.p`
    color: #ffffff;
    font-family:"AMX-Regular";
    font-size: ${props => props.isContainerTelcel ? "16px" : "18px"};
    text-align: center;
    margin: ${props => props.isContainerTelcel ? "0px 10% 24px 10%" : "5% 10% 10% 10%"};
    ${props => props.isContainerTelcel ? "line-height: 24px" : ""}
`;

const Img = styled.img`
    width: ${props => props.isContainerTelcel ? "390px" : "75%"};
    text-align: center;
    ${props => props.isContainerTelcel ? "max-width: 100%" : ""}
`;

const ImgContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    text-align: center;
    ${props => props.isContainerTelcel ? "margin-bottom: 32px" : ""}
`;

const Button  = styled.div`
    border-radius: ${props => props.isContainerTelcel ? "40px" : "25px"};
    background: ${(props) => (props.background ? props.background  : "#000" )};
    width: ${props => props.isContainerTelcel ? "240px" : "215px"};
    ${props => !props.isContainerTelcel ? "height: 34px" : ""}
    display:flex;
    align-items:center;
    justify-content:center;
    margin: ${(props) => (props.margin ? props.margin  : "5% auto" )}; 
    padding: ${props => props.isContainerTelcel ? "12px 0px 9px 0px" : "5px"};
    text-align: center;
    border: ${(props) => (props.border ? props.border  : "1px solid #000" )};
    color: ${(props) => (props.color ? props.color  : "#fff" )};
    font-family: "AMX-Bold";
    font-size: ${props => props.isContainerTelcel ? "16px" : "16px"};
`;

const Link  = styled.p`
    width: 50%;
    margin: ${(props) => (props.margin ? props.margin  : "5% auto 10% auto" )}; 
    text-align: center;
    color: ${(props) => (props.color ? props.color  : "#fff" )};
    text-decoration: underline;
    font-family:"AMX-Bold";
    font-size: ${props => props.isContainerTelcel ? "16px" : "14px"};
`;

const ToolTipMiTelcel = ({ 
    isOpen, 
    tooltipInformation, 
    handleCloseHelpTooltip,
    handleNextAction,
    handleDontShowAgain,
    isContainerTelcel
}) => {
    const {subject, message, icon, buttons} = tooltipInformation.data
    const data = 'lorem <strong>ipsum</strong>'

    return (
        <ModalCustomized isOpen={isOpen} isContainerTelcel={isContainerTelcel}>
            <Title dangerouslySetInnerHTML={{__html: subject}} isContainerTelcel={isContainerTelcel}></Title>
            <Subtitle dangerouslySetInnerHTML={{__html: message}} isContainerTelcel={isContainerTelcel}></Subtitle>
        <ImgContainer isContainerTelcel={isContainerTelcel}>
            <Img
                src={icon}
                alt={""}
                isContainerTelcel={isContainerTelcel}
            />
        </ImgContainer>
        {
            buttons[0] ? <Button 
                isContainerTelcel={isContainerTelcel}
                background={"#fff"} 
                color={!isContainerTelcel ? "#000" : "#1e1e1e"}
                margin={!isContainerTelcel ? "10% auto 5% auto" : "0px auto 20px auto"}
                onClick={handleNextAction}
            >
                {buttons[0]}
            </Button> :<></>
        }
        {
            buttons[1] ? <Button 
                isContainerTelcel={isContainerTelcel}
                background={"rgba(0, 0, 0, 0.1)"} 
                color={"#fff"}
                border={"1px solid #fff"}
                onClick={handleCloseHelpTooltip}
                margin={!isContainerTelcel ? undefined : "0px auto 24px auto"}
            >
            {buttons[1]}
            </Button> : <></>
        }
        {
            buttons[2] ? <Link
                isContainerTelcel={isContainerTelcel}
                onClick={handleDontShowAgain}
            >
                {buttons[2]}
            </Link> : <></>
        }

        {
            <>
                <br />
                &nbsp;
            </>           
        }
        </ModalCustomized>
        
        
    );
};

export default ToolTipMiTelcel;